import { render, staticRenderFns } from "./practice-selection.vue?vue&type=template&id=61a574ba"
import script from "./practice-selection.vue?vue&type=script&lang=ts"
export * from "./practice-selection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports